/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const deleteAlumniProfile = /* GraphQL */ `
  mutation DeleteAlumniProfile(
    $input: DeleteAlumniProfileInput!
    $condition: ModelAlumniProfileConditionInput
  ) {
    deleteAlumniProfile(input: $input, condition: $condition) {
      id
      firstName
      firstNameDisplay
      lastName
      lastNameDisplay
      about
      isOpenToWork
      isWillingToTravel
      publicProfile
      skills
      owner
      linkedInUrl
      countryCode
      stateCode
      cityName
      branch
      cohortID
      email
      isMilitarySpouse
      profilePictureKey
      occupation
      headline
      experiences {
        startsAt {
          day
          month
          year
        }
        endsAt {
          day
          month
          year
        }
        company
        title
        description
        location
        logoUrl
      }
      educations {
        startsAt {
          day
          month
          year
        }
        endsAt {
          day
          month
          year
        }
        fieldOfStudy
        degreeName
        school
        description
        logoUrl
      }
      certifications {
        startsAt {
          day
          month
          year
        }
        endsAt {
          day
          month
          year
        }
        url
        name
        licenseNumber
        displaySource
        authority
      }
      createdAt
      updatedAt
    }
  }
`;
export const createCohort = /* GraphQL */ `
  mutation CreateCohort(
    $input: CreateCohortInput!
    $condition: ModelCohortConditionInput
  ) {
    createCohort(input: $input, condition: $condition) {
      id
      name
      year
      alumni {
        items {
          id
          firstName
          firstNameDisplay
          lastName
          lastNameDisplay
          about
          isOpenToWork
          isWillingToTravel
          publicProfile
          skills
          owner
          linkedInUrl
          countryCode
          stateCode
          cityName
          branch
          cohortID
          email
          isMilitarySpouse
          profilePictureKey
          occupation
          headline
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateCohort = /* GraphQL */ `
  mutation UpdateCohort(
    $input: UpdateCohortInput!
    $condition: ModelCohortConditionInput
  ) {
    updateCohort(input: $input, condition: $condition) {
      id
      name
      year
      alumni {
        items {
          id
          firstName
          firstNameDisplay
          lastName
          lastNameDisplay
          about
          isOpenToWork
          isWillingToTravel
          publicProfile
          skills
          owner
          linkedInUrl
          countryCode
          stateCode
          cityName
          branch
          cohortID
          email
          isMilitarySpouse
          profilePictureKey
          occupation
          headline
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteCohort = /* GraphQL */ `
  mutation DeleteCohort(
    $input: DeleteCohortInput!
    $condition: ModelCohortConditionInput
  ) {
    deleteCohort(input: $input, condition: $condition) {
      id
      name
      year
      alumni {
        items {
          id
          firstName
          firstNameDisplay
          lastName
          lastNameDisplay
          about
          isOpenToWork
          isWillingToTravel
          publicProfile
          skills
          owner
          linkedInUrl
          countryCode
          stateCode
          cityName
          branch
          cohortID
          email
          isMilitarySpouse
          profilePictureKey
          occupation
          headline
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createAlumniProfile = /* GraphQL */ `
  mutation CreateAlumniProfile(
    $input: CreateAlumniProfileInput!
    $condition: ModelAlumniProfileConditionInput
  ) {
    createAlumniProfile(input: $input, condition: $condition) {
      id
      firstName
      firstNameDisplay
      lastName
      lastNameDisplay
      about
      isOpenToWork
      isWillingToTravel
      publicProfile
      skills
      owner
      linkedInUrl
      countryCode
      stateCode
      cityName
      branch
      cohortID
      email
      isMilitarySpouse
      profilePictureKey
      occupation
      headline
      experiences {
        startsAt {
          day
          month
          year
        }
        endsAt {
          day
          month
          year
        }
        company
        title
        description
        location
        logoUrl
      }
      educations {
        startsAt {
          day
          month
          year
        }
        endsAt {
          day
          month
          year
        }
        fieldOfStudy
        degreeName
        school
        description
        logoUrl
      }
      certifications {
        startsAt {
          day
          month
          year
        }
        endsAt {
          day
          month
          year
        }
        url
        name
        licenseNumber
        displaySource
        authority
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateAlumniProfile = /* GraphQL */ `
  mutation UpdateAlumniProfile(
    $input: UpdateAlumniProfileInput!
    $condition: ModelAlumniProfileConditionInput
  ) {
    updateAlumniProfile(input: $input, condition: $condition) {
      id
      firstName
      firstNameDisplay
      lastName
      lastNameDisplay
      about
      isOpenToWork
      isWillingToTravel
      publicProfile
      skills
      owner
      linkedInUrl
      countryCode
      stateCode
      cityName
      branch
      cohortID
      email
      isMilitarySpouse
      profilePictureKey
      occupation
      headline
      experiences {
        startsAt {
          day
          month
          year
        }
        endsAt {
          day
          month
          year
        }
        company
        title
        description
        location
        logoUrl
      }
      educations {
        startsAt {
          day
          month
          year
        }
        endsAt {
          day
          month
          year
        }
        fieldOfStudy
        degreeName
        school
        description
        logoUrl
      }
      certifications {
        startsAt {
          day
          month
          year
        }
        endsAt {
          day
          month
          year
        }
        url
        name
        licenseNumber
        displaySource
        authority
      }
      createdAt
      updatedAt
    }
  }
`;
